<template>
  <footer class="app-footer">
    <a href="http://applyit.lv" target="_blank">Apply</a> &copy; 2018
    <!--<span class="float-right">Powered by <a href="http://coreui.io">CoreUI</a></span>-->
  </footer>
</template>
<script>
export default {
  name: 'Footer'
};
</script>
